// import { createRouter, createWebHistory } from 'vue-router'
import { createRouter, createWebHashHistory } from 'vue-router'
import LoginView from '@/views/LoginView.vue'
import HomeView from '@/views/HomeView.vue'
import RegisterView from '@/views/RegisterView.vue'
import ProfileView from '@/views/ProfileView.vue'
import UpdatePasswordView from '@/views/UpdatePasswordView.vue'
import ContactUs from '@/views/ContactUsView.vue'
import MyCardsView from '@/views/MyCardsView.vue'
import CardRecharge from '@/views/CardRecharge/CardRechargeView.vue'
import RecoverPasswordView from '@/views/RecoverPasswordView.vue'
import CardPaymentView from '@/views/CardRecharge/CardPaymentView.vue'
import NewCardPaymentView from '@/views/CardRecharge/NewCardPaymentView.vue'
import PixPaymentView from '@/views/CardRecharge/PixPaymentView.vue'
import MenuView from '@/views/Menu/MenuView.vue'
import RestaurantMenuView from '@/views/Menu/RestaurantMenuView.vue'
import FullBalanceView from '@/views/FullBalanceView.vue'

// dependent
import DependentView from '@/views/Dependent/DependentView.vue'
import BalanceView from '@/views/Dependent/BalanceView.vue'
import AutomaticRecharge from '@/views/Dependent/AutomaticRechargeView.vue'
import QrCodeView from '@/views/Dependent/QrCodeView.vue'
import FinancialSummaryView from '@/views/Dependent/FinancialSummaryView.vue'
import ExtractView from '@/views/Dependent/ExtractView.vue'
import FoodRestrictionView from '@/views/Dependent/FoodRestrictionView.vue'
import ValueRestrictionview from '@/views/Dependent/ValueRestrictionView.vue'
import FinancialResponsibleView from '@/views/Dependent/FinancialResponsibleView.vue'
import InvoiceSummaryView from '@/views/Dependent/InvoiceSummaryView.vue'
import SubscriptionServices from '@/views/Dependent/SubscriptionServicesView.vue'
import OffLineViewVue from '@/views/OffLineView.vue'

import { getLocalVar } from '@/libs/Util'

const routes = [
    {
        path: '/',
        name: 'login',
        meta: { guest: true },
        component: LoginView
    },
    // {
    //     path: '/home',
    //     name: 'home',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue')
    // },
    {
        path: '/home',
        name: 'home',
        component: HomeView
    },
    {
        path: '/register',
        name: 'register',
        component: RegisterView,
        meta: { guest: true }
    },
    {
        path: '/profile',
        name: 'profile',
        component: ProfileView
    },
    {
        path: '/updatePassword',
        name: 'updatePassword',
        component: UpdatePasswordView
    },
    {
        path: '/contactUs',
        name: 'contactUs',
        component: ContactUs
    },
    {
        path: '/myCards',
        name: 'myCards',
        component: MyCardsView
    },
    {
        path: '/cardRecharge',
        name: 'cardRecharge',
        component: CardRecharge
    },
    {
        path: '/recoverpassword',
        name: 'recoverpassword',
        component: RecoverPasswordView,
        meta: { guest: true }
    },
    {
        path: '/cardRecharge/cardPayment',
        name: 'cardPayment',
        component: CardPaymentView
    },
    {
        path: '/cardRecharge/newCardPayment',
        name: 'newCardPayment',
        component: NewCardPaymentView
    },
    {
        path: '/cardRecharge/pixPayment',
        name: 'pixPayment',
        component: PixPaymentView
    },
    {
        path: '/dependent',
        name: 'dependent',
        component: DependentView
    },
    {
        path: '/dependent/balance',
        name: 'balance',
        component: BalanceView
    },
    {
        path: '/dependent/automaticRecharge',
        name: 'automaticRecharge',
        component: AutomaticRecharge
    },
    {
        path: '/dependent/qrcode',
        name: 'qrcode',
        component: QrCodeView
    },
    {
        path: '/dependent/financialSummary',
        name: 'financialSummary',
        component: FinancialSummaryView
    },
    {
        path: '/dependent/extract',
        name: 'extract',
        component: ExtractView
    },
    {
        path: '/dependent/foodRestriction',
        name: 'foodRestriction',
        component: FoodRestrictionView
    },
    {
        path: '/dependent/valueRestriction',
        name: 'valueRestriction',
        component: ValueRestrictionview
    },
    {
        path: '/menu',
        name: 'menu',
        component: MenuView
    },
    {
        path: '/menu/restaurant/',
        name: 'RestaurantMenuView',
        component: RestaurantMenuView
    },
    {
        path: '/dependent/financialResponsible',
        name: 'financialResponsible',
        component: FinancialResponsibleView
    },
    {
        path: '/fullBalance',
        name: 'fullBalance',
        component: FullBalanceView
    },
    {
        path: '/dependent/invoiceSummary',
        name: 'invoiceSummary',
        component: InvoiceSummaryView
    },
    {
        path: '/dependent/subscriptionServices',
        name: 'subscriptionServices',
        component: SubscriptionServices
    },
    {
        path: '/offline',
        name: 'offline',
        component: OffLineViewVue
    }
]

const router = createRouter({
    // history: createWebHistory(process.env.BASE_URL),
    history: createWebHashHistory(),
    routes
})
router.beforeEach((to, from, next) => {
    const lastRoute = localStorage.getItem('lastRoute')
    if (!to.meta.guest) {
        // check if use already logged
        const logged = getLocalVar('SESSIONTOKEN')
        // if true then go to home
        if (!logged) {
            return next({ path: '/' })
        }
    }
    // Check if the navigation is a page reload
    if (to.path === lastRoute && to.path !== '/home') {
        next('/home')
    } else {
        if (to.path !== '/' && to.path !== '/register' && to.path !== '/recoverpassword') {
            localStorage.setItem('lastRoute', to.path)
        }
        next()
    }
})

export default router
